import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "webinar_card_icon_add_asset",
  "use": "webinar_card_icon_add_asset-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"webinar_card_icon_add_asset\"><path d=\"M10 2c-4.416 0-8 3.584-8 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8Zm3.2 8.8h-2.4v2.4c0 .44-.36.8-.8.8-.44 0-.8-.36-.8-.8v-2.4H6.8c-.44 0-.8-.36-.8-.8 0-.44.36-.8.8-.8h2.4V6.8c0-.44.36-.8.8-.8.44 0 .8.36.8.8v2.4h2.4c.44 0 .8.36.8.8 0 .44-.36.8-.8.8Z\" fill=\"#2C2D2E\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol